import { api_GET, api_POST, api_PUT } from './_api';
import { getSessionCookie } from "../helpers/cookies.js";

const dashboard_api = {
    GetDashboard: (filtros) => {
        const session = getSessionCookie();
        const promise = new Promise((resolve, reject) => {
            api_POST(`Dashboard/${session.acesso.modulo}/`, filtros).then(result => {
                resolve(result);
            }).catch(e => {
                reject(e);
            });
        });
        return promise;
    },
    VeiculosPorModalidade: (modalidadeId) => {
        const session = getSessionCookie();
        const promise = new Promise((resolve, reject) => {
            api_GET(`Dashboard/VeiculosPorModalidade/` + modalidadeId).then(result => {
                resolve(result);
            }).catch(e => {
                reject(e);
            });
        });
        return promise;
    },
    ContratosPorModalidade: (modalidadeId, prefeituraId) => {
        const session = getSessionCookie();
        const promise = new Promise((resolve, reject) => {
            api_GET(`Dashboard/ContratosPorModalidade/${modalidadeId}/${prefeituraId}`).then(result => {
                resolve(result);
            }).catch(e => {
                reject(e);
            });
        });
        return promise;
    },
    GetAgendamentos: async (filtros) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Dashboard/GetAgendamentos/`, filtros)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    TransportadoresPorModalidade: async (filtros) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Dashboard/TransportadoresPorModalidade/`, filtros)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GeradoresContratos: (prefeitura_id, option) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Dashboard/GeradoresContratos/${prefeitura_id}${option ? `?option=${option}` : ""}`).then(result => {
                resolve(result);
            }).catch(e => {
                reject(e);
            });
        });
        return promise;
    },
    GeradoresSemPGRS:  () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Dashboard/GeradoresSemPGRS/`).then(result => {
                resolve(result);
            }).catch(e => {
                reject(e);
            });
        });
        return promise;
    },
    GetIndicadoresGeradorPGRS: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Dashboard/GetIndicadoresGeradorPGRS/`).then(result => {
                resolve(result);
            }).catch(e => {
                reject(e);
            });
        });
        return promise;
    },
    GeradoresAguardandoAtivacaoContratoPGRS: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Dashboard/GeradoresAguardandoAtivacaoContratoPGRS/`).then(result => {
                resolve(result);
            }).catch(e => {
                reject(e);
            });
        });
        return promise;
    },
}

export default dashboard_api;
